import { render } from "./ImsiPricesSettings.vue?vue&type=template&id=9df92696"
import script from "./ImsiPricesSettings.vue?vue&type=script&lang=js"
export * from "./ImsiPricesSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__